import i18next from "i18next";
import _isNumber from "lodash/isNumber";

import { ThemeEnum } from "@app/constants/theme.constants";
import { ClassesDef } from "@app/features/classes/classes";
import { ApiFormErrorsDef } from "@app/types/api.types";
import {PractitionerDef} from '@app/features/practitioners/practitioners';

export const validateEnum = (enumName: any, enumValue: string) =>
  Object.values(enumName).includes(enumValue);

/**
 * Check if a string looks like an external or internal link
 */
export const isURL = (str: string) => {
  return /http|www|\./.test(str);
};

export const convertToSlug = (str: string) => {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
    .replace(/\s+/g, "-") // collapse whitespace and replace by -
    .replace(/-+/g, "-") // collapse dashes
    .replace(/^-+/, "") // trim - from start of text
    .replace(/-+$/, ""); // trim - from end of text
};

export function getPublishedData<T = any>(data: T[]): T[] {
  return data ? data.filter((item: any) => !!item.fields) : [];
}

export function randomNumber(min: number, max: number) {
  return Math.floor(Math.random() * (max - min) + min);
}

export function isValidId(id: string) {
  return !!id && _isNumber(Number(id));
}

export function removeUndefined(
  values: Record<string, any>,
  ignoreKeys: string[] = []
) {
  Object.keys(values).forEach(
    key =>
      (values[key] == null || values[key].length === 0) &&
      !ignoreKeys.includes(key) &&
      delete values[key]
  );
}

export const getTheme = (theme: ThemeEnum) => `${theme}-theme`;

export function getFullName<T = any>(data?: T): string {
  const obj = data as any;

  if (obj?.name) {
    return obj.name;
  }

  if (obj?.firstName || obj?.lastName) {
    return `${obj.firstName} ${obj.lastName}`;
  }

  return "";
}

export function getPractitionerName(session: ClassesDef): string {
  if (session.type === "workshop") {
    if ((session.practitioner as unknown as PractitionerDef[]).length > 1){
      return "Multiple Practitioners";
    }
    return getFullName(session.practitioner[0]);
  }

  return getFullName(session.practitioner);
}

export function isEmpty(word: string) {
  return !word?.trim();
}

/**
 * Lookup error message keys with translation keys
 */
export function mapErrorFields(errors: ApiFormErrorsDef) {
  const modifiedErrors: Record<string, string> = {};

  Object.keys(errors).forEach(fieldName => {
    // Take the first available error to show against the field
    modifiedErrors[fieldName] = i18next.t(
      `errorMessages.${fieldName}${errors[fieldName][0]}`
    );
  });

  return modifiedErrors;
}

export function hexToRGB(hex: string|undefined, alpha: number) {
  if (!hex){
    return null;
  }
  const r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  } else {
    return `rgba(${r}, ${g}, ${b})`;
  }
}